var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBamOnlineWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 476.6 236.2",
    style: {
      enableBackground: "new 0 0 476.6 236.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1410AC;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M434.9,160.4c-0.9,0-1.6-0.7-1.6-1.6V1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v157.2 C436.5,159.7,435.8,160.4,434.9,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.7,160.4c-0.6,0-1.2-0.3-1.4-0.9l-72-144.1c-0.4-0.8-0.1-1.8,0.7-2.2c0.8-0.4,1.8-0.1,2.2,0.7 l72,144.1c0.4,0.8,0.1,1.8-0.7,2.2C278.2,160.3,278,160.4,277.7,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M264.6,160.4c-0.6,0-1.2-0.3-1.4-0.9l-65.5-131c-0.4-0.8-0.1-1.8,0.7-2.2c0.8-0.4,1.8-0.1,2.2,0.7 l65.5,131c0.4,0.8,0.1,1.8-0.7,2.2C265.1,160.3,264.9,160.4,264.6,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.3,147.3c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c20.8,0,37.7-16.9,37.7-37.7 c0-20.8-16.9-37.7-37.7-37.7c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c22.6,0,40.9,18.4,40.9,40.9S103.8,147.3,81.3,147.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.3,134.2c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c13.6,0,24.6-11,24.6-24.6 c0-13.6-11-24.6-24.6-24.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c15.3,0,27.8,12.5,27.8,27.8 C109.1,121.7,96.6,134.2,81.3,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.3,121.1c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c6.3,0,11.5-5.1,11.5-11.5 c0-6.3-5.1-11.5-11.5-11.5c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c8.1,0,14.7,6.6,14.7,14.7 C96,114.5,89.4,121.1,81.3,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.3,55.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c13.6,0,24.6-11,24.6-24.6 c0-13.6-11-24.6-24.6-24.6c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c15.3,0,27.8,12.5,27.8,27.8 C109.1,43.1,96.6,55.6,81.3,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.3,42.5c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c6.3,0,11.5-5.2,11.5-11.5 c0-6.3-5.1-11.5-11.5-11.5c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c8.1,0,14.7,6.6,14.7,14.7 C96,35.9,89.4,42.5,81.3,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.3,160.4c-0.9,0-1.6-0.7-1.6-1.6V1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v157.2 C82.9,159.7,82.2,160.4,81.3,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.2,160.4c-0.9,0-1.6-0.7-1.6-1.6V1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v157.2 C69.8,159.7,69.1,160.4,68.2,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.8,160.4c-0.9,0-1.6-0.7-1.6-1.6V1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v157.2 C17.4,159.7,16.7,160.4,15.8,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.7,160.4c-0.9,0-1.6-0.7-1.6-1.6V1.6C1.1,0.7,1.8,0,2.7,0c0.9,0,1.6,0.7,1.6,1.6v157.2 C4.3,159.7,3.6,160.4,2.7,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.9,68.7c-0.6,0-1.2-0.3-1.4-0.9L328.7,2.3c-0.4-0.8-0.1-1.8,0.7-2.2c0.8-0.4,1.8-0.1,2.2,0.7 l32.7,65.5c0.4,0.8,0.1,1.8-0.7,2.2C363.4,68.7,363.1,68.7,362.9,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M369.4,55.6c-0.6,0-1.2-0.3-1.4-0.9L341.8,2.3c-0.4-0.8-0.1-1.8,0.7-2.2c0.8-0.4,1.8-0.1,2.2,0.7 l26.2,52.4c0.4,0.8,0.1,1.8-0.7,2.2C369.9,55.6,369.7,55.6,369.4,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.7,160.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C409.9,160.1,409.3,160.4,408.7,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.6,160.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l26.2-52.4c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-26.2,52.4C396.8,160.1,396.2,160.4,395.6,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.6,134.2c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l26.2-52.4c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-26.2,52.4C396.8,133.9,396.2,134.2,395.6,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.6,108c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l26.2-52.4c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-26.2,52.4C396.8,107.7,396.2,108,395.6,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.6,81.8c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l26.2-52.4c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-26.2,52.4C396.8,81.5,396.2,81.8,395.6,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.6,55.6c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l26.2-52.4c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-26.2,52.4C396.8,55.3,396.2,55.6,395.6,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.6,29.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C396.8,29.1,396.2,29.4,395.6,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42,160.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C43.2,160.1,42.6,160.4,42,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,160.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l26.2-52.4c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-26.2,52.4C30.1,160.1,29.5,160.4,28.9,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,134.2c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l26.2-52.4c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-26.2,52.4C30.1,133.9,29.5,134.2,28.9,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,108c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l26.2-52.4c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-26.2,52.4C30.1,107.7,29.5,108,28.9,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,81.8c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l26.2-52.4c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2L30.3,80.9C30.1,81.5,29.5,81.8,28.9,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,55.6c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2L53.6,0.9C54,0.1,55-0.2,55.8,0.2 c0.8,0.4,1.1,1.4,0.7,2.2L30.3,54.7C30.1,55.3,29.5,55.6,28.9,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,29.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2L40.6,0.9c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2L30.3,28.5C30.1,29.1,29.5,29.4,28.9,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.7,94.9c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2L338.1,94C337.8,94.6,337.3,94.9,336.7,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M330.1,81.8c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C331.3,81.5,330.7,81.8,330.1,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M323.6,68.7c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2L325,67.8C324.7,68.4,324.2,68.7,323.6,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M317,55.6c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C318.2,55.3,317.6,55.6,317,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.5,42.5c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2L322.1,14c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C311.6,42.2,311.1,42.5,310.5,42.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.9,29.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C305.1,29.1,304.5,29.4,303.9,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M297.4,16.3c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l6.5-13.1c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-6.6,13.1C298.5,16,298,16.3,297.4,16.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.6,68.7c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C193.8,68.4,193.2,68.7,192.6,68.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M199.2,81.8c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C200.3,81.5,199.8,81.8,199.2,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M205.7,94.9c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2L207.2,94C206.9,94.6,206.3,94.9,205.7,94.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.3,108c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C213.4,107.7,212.8,108,212.3,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.8,121.1c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C220,120.8,219.4,121.1,218.8,121.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.4,134.2c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C226.5,133.9,225.9,134.2,225.4,134.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M231.9,147.3c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C233.1,147,232.5,147.3,231.9,147.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.5,160.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l13.1-26.2c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-13.1,26.2C239.6,160.1,239,160.4,238.5,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.5,160.4c-0.2,0-0.5-0.1-0.7-0.2c-0.8-0.4-1.1-1.4-0.7-2.2l6.5-13.1c0.4-0.8,1.4-1.1,2.2-0.7 c0.8,0.4,1.1,1.4,0.7,2.2l-6.5,13.1C252.7,160.1,252.1,160.4,251.5,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.9,160.4c-0.9,0-1.6-0.7-1.6-1.6V1.6C27.3,0.7,28,0,28.9,0c0.9,0,1.6,0.7,1.6,1.6v157.2 C30.5,159.7,29.8,160.4,28.9,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.1,160.4c-0.9,0-1.6-0.7-1.6-1.6V1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v157.2 C56.7,159.7,56,160.4,55.1,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M395.6,160.4c-0.9,0-1.6-0.7-1.6-1.6V8.4l-49.3,98.7c-0.5,1.1-2.3,1.1-2.9,0L292.5,8.4v150.3 c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6V1.6c0-0.8,0.5-1.4,1.2-1.6c0.7-0.2,1.5,0.2,1.8,0.8l50.9,101.9L394.2,0.9 c0.3-0.7,1.1-1,1.8-0.8c0.7,0.2,1.2,0.8,1.2,1.6v157.2C397.2,159.7,396.5,160.4,395.6,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M356.3,81.8c-0.6,0-1.2-0.3-1.4-0.9L315.6,2.3c-0.4-0.8-0.1-1.8,0.7-2.2c0.8-0.4,1.8-0.1,2.2,0.7 l39.3,78.6c0.4,0.8,0.1,1.8-0.7,2.2C356.8,81.8,356.6,81.8,356.3,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M421.8,160.4c-0.9,0-1.6-0.7-1.6-1.6V1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v157.2 C423.4,159.7,422.7,160.4,421.8,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.3,160.4c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c28,0,50.8-22.8,50.8-50.8 c0-28-22.8-50.8-50.8-50.8c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6c29.8,0,54,24.2,54,54 C135.3,136.2,111.1,160.4,81.3,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.8,160.4c-0.6,0-1.2-0.3-1.4-0.9L212.3,5.2l-77.1,154.3c-0.4,0.8-1.4,1.1-2.2,0.7 c-0.8-0.4-1.1-1.4-0.7-2.2L210.8,0.9c0.5-1.1,2.3-1.1,2.9,0l78.6,157.2c0.4,0.8,0.1,1.8-0.7,2.2 C291.3,160.3,291.1,160.4,290.8,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238.5,160.4c-0.6,0-1.2-0.3-1.4-0.9L184.6,54.7c-0.4-0.8-0.1-1.8,0.7-2.2c0.8-0.4,1.8-0.1,2.2,0.7 l52.4,104.8c0.4,0.8,0.1,1.8-0.7,2.2C238.9,160.3,238.7,160.4,238.5,160.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.3,108h-52.4c-0.9,0-1.6-0.7-1.6-1.6c0-0.9,0.7-1.6,1.6-1.6h52.4c0.9,0,1.6,0.7,1.6,1.6 C213.9,107.3,213.2,108,212.3,108z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M448.5,160.4c-0.9,0-1.6-0.7-1.6-1.6V1.6c0-0.9,0.7-1.6,1.6-1.6c0.9,0,1.6,0.7,1.6,1.6v157.2 C450.1,159.7,449.3,160.4,448.5,160.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,186.4h2.1L3.2,198.1l12.6,12.5h-2L2.2,199.1l-0.6,0.6v10.9H0v-24.2h1.5v11.3L13,186.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.8,202.7l-3.2,8h-1.6l10.1-25l10.1,25h-1.6l-3.2-8H32.8z M38.1,189.5l-4.7,11.7h9.5L38.1,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75,210.6h-1.8l-7.9-11.4h-0.8v11.4h-1.5v-24.2h3c2,0,3.9,0,5.5,1.2c1.7,1.2,2.4,3.1,2.4,5.2 c0,4.2-2.9,6.4-6.9,6.3L75,210.6z M66.6,197.7c1.5,0,3-0.1,4.2-1.1c1.2-0.9,1.7-2.4,1.7-3.8c0-1.8-0.8-3.6-2.6-4.4 c-1.3-0.6-2.9-0.5-4.3-0.5h-1v9.8H66.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.2,202.7l-3.2,8h-1.6l10.1-25l10.1,25h-1.6l-3.2-8H93.2z M98.5,189.5l-4.7,11.7h9.5L98.5,189.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.2,198.5c0,6.8-5.7,12.4-12.5,12.4c-6.8,0-12.5-5.6-12.5-12.4s5.7-12.4,12.5-12.4 C141.4,186.1,147.2,191.7,147.2,198.5z M123.6,198.5c0,6,5,11,11,11c6,0,11-5,11-11c0-6-5-11-11-11 C128.6,187.5,123.6,192.6,123.6,198.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176,186.4h2.1l-11.8,11.6l12.6,12.5h-2l-11.6-11.5l-0.6,0.6v10.9H163v-24.2h1.5v11.3L176,186.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.9,187.9v8.8h9.7v1.4h-9.7v11.1h10v1.4h-11.5v-24.2h11.5v1.4H194.9z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 232.2,
    y: 145.7,
    transform: "matrix(0.9881 -0.154 0.154 0.9881 -23.818 56.4427)",
    className: "st1",
    width: 240.2,
    height: 72.4
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.1,198.9c-0.9-5.6,0.4-10.8,3.8-15.6c3.5-4.7,8.1-7.6,13.9-8.5c5.7-0.9,11,0.3,15.7,3.7 c4.8,3.4,7.6,8,8.6,13.7c0.9,5.8-0.3,11-3.8,15.7c-3.5,4.7-8.2,7.5-14,8.5c-5.2,0.8-10.1-0.2-14.8-3.1 C249.2,210.2,246.1,205.4,245.1,198.9z M251.2,198c0.7,4.4,2.8,7.8,6.2,10.2c3.4,2.4,7.1,3.3,11,2.6c4.2-0.7,7.5-2.7,9.9-6.1 c2.4-3.4,3.3-7.2,2.6-11.5c-0.7-4.3-2.7-7.6-6-10.1c-3.3-2.4-7.1-3.3-11.3-2.7c-4.2,0.7-7.5,2.7-9.9,6.1 C251.3,190,250.5,193.8,251.2,198z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M300,210.8l-7-42.9l34.2,25.9l-4.5-27.9l6.1-1l6.9,42.6l-34.2-25.8l4.6,28.1L300,210.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.6,162l5.6,34.4l11.8-1.9l0.9,5.7l-17.9,2.9l-6.5-40.1L346.6,162z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.4,157.8l6.5,40.1l-6.1,1l-6.5-40.1L372.4,157.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M390.7,196l-7-42.9l34.2,25.9l-4.5-27.9l6.1-1l6.9,42.6L392.1,167l4.6,28.1L390.7,196z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M454.3,150.3l-16.1,2.6l1.6,9.6l15.6-2.5l0.9,5.7l-15.6,2.5l2.2,13.4l16.1-2.6l0.9,5.7l-22.1,3.6l-6.5-40.1 l22.1-3.6L454.3,150.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBamOnlineWhite);
export default __webpack_public_path__ + "static/media/logo-bam-online-white.05a5a0f7bf4eca775c19ce02f875b29b.svg";
export { ForwardRef as ReactComponent };